import styled from 'styled-components';
import { ThemeType } from '../../../../types/Theme';

const ConfiguracoesAvancadasContainer = styled.div<{theme: ThemeType}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.colors.modal};
  color: ${({ theme }) => theme.colors.tertiary};
  padding: 4rem;
  margin: 0 auto;
  border-radius: 5rem;
  max-width: 485px;
  min-width: 400px;
  width: 100%;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  overflow: hidden;
  max-height: 80vh;
  overflow-y: auto;

  .confirm-class {
    background-color: rgb(255, 110, 40);
  }

  .remover-imagens {
    width: 100%;
    margin: 2rem 0 0 0;
    display: flex;
    background-color: ${({theme}) => theme.colors.modal} !important;
    color: ${({ theme }) => theme.colors.tertiary};
    gap: 2rem;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;

    .texto {
      padding-bottom: 15px;
    }

    Button {
    color: rgb(225, 225, 225);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    }
    label {
      font-family: 'Inter';
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
      color: ${({ theme }) => theme.colors.tertiary};
    }

    p {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;

const Botoes = styled.div<{theme: ThemeType}>`
  display: flex;
  justify-content: unset;
  align-items: start;
  cursor: pointer;
  width: 100%;

  .cancelar {
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      fill: ${(props) => props.theme.colors.primary};
      transform: rotate(90deg);
    }
  }
`;

export {
  ConfiguracoesAvancadasContainer, Botoes
};
